const BigNumber = require('bignumber.js');

export default {
  methods: {
    /* eslint-disable */
    formatMoney(e, decimalCount = 0, decimal = '.', thousands = '\'') {
      let amount = e.target.value;
      try {
        decimalCount = Math.abs(decimalCount) ? 2 : decimalCount;
        decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

        const negativeSign = amount < 0 ? '-' : '';

        // const i = parseInt(amount = new BigNumber(Math.abs(new BigNumber(amount) || 0)).toFixed(decimalCount)).toString();
        const i =  new BigNumber(amount).toFixed(0);
        const j = (i.length > 3) ? i.length % 3 : 0;

        if(!isNaN(i)) {
          e.target.value = negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, `$1${thousands}`) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : '');
        }
      } catch (e) {
        Vue.$log.error(e);
      }
    },
    /* eslint-disable */
    formatCurrency(amount, decimalCount = 0, decimal = '.', thousands = '\'') {
      try {
        decimalCount = Math.abs(decimalCount) ? 2 : decimalCount;
        decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

        const negativeSign = amount < 0 ? '-' : '';

        // const i = parseInt(amount = new BigNumber(Math.abs(new BigNumber(amount) || 0)).toFixed(decimalCount)).toString();
        const i =  new BigNumber(amount).toFixed(decimalCount);
        const j = (i.length > 3) ? i.length % 3 : 0;

        if(isNaN(i)){
          return 0;
        }
        const res = negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, `$1${thousands}`) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : '');
        return res;
      } catch (e) {
        Vue.$log.error(e);
      }
    },
    // Restricts input for the given textbox to the given inputFilter.
    setInputFilter(textbox, inputFilter) {
      ['input', 'keydown', 'keyup', 'mousedown', 'mouseup', 'select', 'contextmenu', 'drop'].forEach((event) => {
        textbox.addEventListener(event, function () {
          if (inputFilter(this.value)) {
            this.oldValue = this.value;
            this.oldSelectionStart = this.selectionStart;
            this.oldSelectionEnd = this.selectionEnd;
          } else if (this.hasOwnProperty('oldValue')) {
            this.value = this.oldValue;
            this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
          }
        });
      });
    },
  },
  mounted() {
    // Restrict input to digits and '.' by using a regular expression filter.
    // this.setInputFilter(document.getElementById(this.nomChamp), value => /^\d{1,20}$/.test(value));
    if(this.nomChamp) {
      this.setInputFilter(document.getElementById(this.nomChamp), value => /^\d*$/.test(value));
    }
  },
};
